import { NodeWithPos } from 'prosemirror-utils'
import { Command } from '../types'

export const editTodoListItemContent: (nodeWithPos: NodeWithPos, newTitle: string) => Command = (
  nodeWithPos,
  newTitle,
) => {
  return (state, dispatch) => {
    const { node, pos } = nodeWithPos
    if (node.type !== state.schema.nodes.list_item) return false
    const paragraphPos = pos + 1
    const paragraphNode = state.doc.resolve(paragraphPos).nodeAfter
    if (!paragraphNode || paragraphNode.type !== state.schema.nodes.paragraph) return false
    const paragraphText = paragraphNode.textContent
    if (paragraphText === newTitle) return false
    const textNode = state.schema.text(newTitle)
    const newParagraphNode = state.schema.nodes.paragraph.create(paragraphNode.attrs, textNode)
    const tr = state.tr.replaceWith(paragraphPos, paragraphPos + paragraphNode.nodeSize, newParagraphNode)
    dispatch?.(tr)

    return true
  }
}
